
export const games = [
  {
    id: 1,
    category: 1,
    name: "The Mini",
    url: "https://www.nytimes.com/crosswords/game/mini",
    image: "mini.png",
    caption: "A quick, simple crossword puzzle. How quickly can you fill it in?",
    scoreType: "time",
    scorePrompt:"How long did it take to complete?",
    isLocked: true,
  },
  {
    id: 2,
    category: 1,
    name: "NYT Daily Crossword",
    url: "https://www.nytimes.com/crosswords/game/daily",
    image: "nytcrossword.png",
    caption: "Solve a large daily crossword puzzle",
    scoreType: "time",
    scorePrompt:"How long did it take to complete?",
    isLocked: true,
  },
  {
    id: 3,
    category: 1,
    name: "LA Times Crossword",
    url: "https://www.latimes.com/games/daily-crossword",
    image: "lacrossword.png",
    caption: "Solve a large daily crossword puzzle",
    scoreType: "time",
    scorePrompt:"How long did it take to complete?",
  },
  {
    id: 4,
    category: 1,
    name: "Missing Letter",
    url: "https://www.merriam-webster.com/games/missing-letter",
    image: "missingletter.png",
    caption: "A crossword with a twist",
  },
  {
    id: 5,
    category: 1,
    name: "Blockables",
    url: "https://www.blockables.app/",
    image: "blockables.png",
    caption: "A crossword with words scattered around and one main phrase spiraling outward. No more daily puzzle, but there's an archive available.",
    scoreType: "time",
    scorePrompt:"How long did it take (with no hints)?",
  },
  {
    id: 6,
    category: 1,
    name: "Connections",
    url: "https://www.nytimes.com/games/connections",
    image: "connections.png",
    caption: "Group the words into sets of four, each related by a topic.",
    scoreType: "int[1]",
    scorePrompt:"How many mistakes did you have remaining?",
  },
  {
    id: 7,
    category: 1,
    name: "Puzzgrid",
    url: "https://puzzgrid.com/best",
    image: "puzzgrid.png",
    caption: "User-made connections puzzles. Group words into related sets of four.",
    scoreType: "int[1]",
    scorePrompt:"Enter your score for the daily puzzle",
  },
  {
    id: 8,
    category: 1,
    name: "Conexo",
    url: "https://conexo.ws/en/daily",
    image: "conexo.png",
    caption: "Group the words into sets of four, each related by a topic.",
    scoreType: "int[2]",
    scorePrompt:"How many guesses did you use?",
  },
  {
    id: 9,
    category: 1,
    name: "Strands",
    url: "https://www.nytimes.com/games/strands",
    image: "strands.png",
    caption: "Connect the letters in a grid to form related words and find the theme that spans from side to side.",
    scoreType: "int[1]",
    scorePrompt:"How many hints did you use?",
  },
  {
    id: 10,
    category: 1,
    name: "Orbits",
    url: "https://www.playorbits.com/",
    image: "orbits.png",
    caption: "Put words in a ring so each forms a two-word phrase with both of its neighbors",
  },
  {
    id: 11,
    category: 1,
    name: "Raddle",
    url: "https://raddle.quest/",
    image: "raddle.png",
    caption: "Guess a series of words with clues that link them, but it's not clear which clue goes to each word.",
    scoreType: "int[3]",
    scorePrompt:"What percentage score did you get?",
  },
  {
    id: 12,
    category: 1,
    name: "Bracket City",
    url: "https://www.theatlantic.com/games/bracket-city/",
    image: "bracketcity.png",
    caption: "Find a phrase with nested clues. Each clue will collapse to form a part of a clue, until one historical fact remains.",
    scoreType: "int[3]",
    scorePrompt:"What percentage score did you get?",
  },
  {
    id: 13,
    category: 1,
    name: "Hang Five",
    url: "https://playhangfive.com/play",
    image: "hangfive.png",
    caption: "Guess one letter at a time to complete five words that are related by a hidden theme.",
    scoreType: "int[1]",
    scorePrompt:"How many hearts did you have remaining?",
  },
  {
    id: 15,
    category: 1,
    name: "Contexto",
    url: "https://contexto.me/",
    image: "contexto.png",
    caption: "Guess a word based on its semantic similarity to previous guesses.",
    scoreType: "int[2]",
    scorePrompt:"How many guesses did you have remaining?",
  },
  {
    id: 16,
    category: 1,
    name: "Semantle",
    url: "https://semantle.com/",
    image: "semantle.png",
    caption: "Guess words by their similarity to words previously guessed.",
    scoreType: "int[2]",
    scorePrompt:"How many guesses did you use?",
  },
  {
    id: 17,
    category: 1,
    name: "Gisnep",
    url: "https://gisnep.com/",
    image: "gisnep.png",
    caption: "Place each letter somewhere in its column to deduce a quotation",
    scoreType: "time",
    scorePrompt:"How long did it take?",
  },
  {
    id: 18,
    category: 1,
    name: "Smug Chicken",
    url: "https://smugchicken.com/",
    image: "smugchicken.png",
    caption: "Guess the word that prompted an AI-generated haiku",
    scoreType: "int[1]",
    scorePrompt:"How many lives did you have remaining?",
  },
  {
    id: 19,
    category: 1,
    name: "Google Feud",
    url: "https://googlefeud.com/",
    image: "googlefeud.png",
    caption: "Guess the top 10 auto-completed phrases for a Google search",
    scoreType: "int[2]",
    scorePrompt:"What was your total score (divided by 1000)?",
  },
  {
    id: 20,
    category: 1,
    name: "Feudle",
    url: "https://googlefeud.com/feudle/",
    image: "feudle.png",
    caption: "Guess the top auto-complete, using Worldle-style clues",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did you take?",
  },
  {
    id: 59,
    category: 2,
    name: "Waffle",
    url: "https://wafflegame.net/",
    image: "waffle.png",
    caption: "Swap the letters to form words in a waffle-shaped grid, in as few moves as possible.",
    scoreType: "int[1]",
    scorePrompt:"How many stars did you earn?",
  },
  {
    id: 60,
    category: 2,
    name: "Word Peaks",
    url: "https://vegeta897.github.io/word-peaks/",
    image: "wordpeaks.png",
    caption: "Deduce a word using higher/lower clues about each letter.",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did it take you?",
    isLinked:1,
  },
  {
    id: 21,
    category: 2,
    name: "Betweenle",
    url: "https://betweenle.com/",
    image: "betweenle.png",
    caption: "Find a word with high-low clues based on alphabetical order.",
    scoreType: "int[2]",
    scorePrompt:"How many guesses did you take (out of 14)?",
  },
  {
    id: 22,
    category: 2,
    name: "Crosswordle",
    url: "https://crosswordle.vercel.app/",
    image: "crosswordle.png",
    caption: "Build a valid Wordle game in reverse, starting with the target word and color-coded clues.",
    scoreType: "time",
    scorePrompt:"How much time did it take?",
  },
  {
    id: 23,
    category: 2,
    name: "Squareword",
    url: "https://squareword.org/",
    image: "squareword.png",
    caption: "Guess a 5x5 square of words using clues about which letters are in each row.",
    scoreType: "int[2]",
    scorePrompt:"How many guesses did it take?",
  },
  {
    id: 24,
    category: 2,
    name: "Letter Boxed",
    url: "https://www.nytimes.com/puzzles/letter-boxed",
    image: "letterboxed.png",
    caption: "Create a series of words by connecting letters around the square.",
    scoreType: "int[2]",
    scorePrompt:"How many words did it take?",
    isLocked: true,
  },
  {
    id: 25,
    category: 2,
    name: "Weaver",
    url: "https://weavergame.org/",
    image: "weaver.png",
    caption: "Transform one word to another in as few moves as possible, changing one letter at a time.",
    scoreType: "int[2]",
    scorePrompt:"How many steps did it take (excluding start and end words)?",
  },
  {
    id: 26,
    category: 2,
    name: "Cell Tower",
    url: "https://www.andrewt.net/puzzles/cell-tower/",
    image: "celltower.png",
    caption: "Group letters to form separate words in this challenging word grid puzzle.",
    scoreType: "bool",
    scorePrompt:"Did you solve the puzzle?",
  },
  {
    id: 27,
    category: 2,
    name: "Crossjig",
    url: "https://crossjig.com/",
    image: "crossjig.png",
    caption: "Place groups of letters onto the board to form words in a Scrabble-like layout.",
  },
  {
    id: 28,
    category: 2,
    name: "Oh Word",
    url: "https://ohword.flanny.app/",
    image: "ohword.png",
    caption: "Move tiles around to form words arranged Scrabble-style to maximize your score",
    scoreType: "int[3]",
    scorePrompt:"What was your total score?",
    isLinked:1,
  },
  // { //is a rip-off?
  //   id: 29,
  //   category: 2,
  //   name: "Squares",
  //   url: "https://squares.org/",
  //   image: "squares.png",
  //   caption: "Find words by connecting the letters in a square grid",
  //   scoreType: "int[3]",
  //   scorePrompt:"hHw many words did you make?",
  // },
  {
    id: 30,
    category: 2,
    name: "Squaredle",
    url: "https://squaredle.app/",
    image: "squaredle.png",
    caption: "Find words by connecting the letters in a square grid",
    scoreType: "int[3]",
    scorePrompt:"hHw many words did you make?",
  },
  {
    id: 31,
    category: 2,
    name: "Spell Bee",
    url: "https://spellbee.org/",
    image: "spellbee.png",
    caption: "Create all the words you can with the letters provided, always using the center letter",
    scoreType: "int[2]",
    scorePrompt:"How many points did you score?",
  },
  {
    id: 32,
    category: 2,
    name: "Spelling Bee",
    url: "https://www.nytimes.com/puzzles/spelling-bee",
    image: "spellingbee.png",
    caption: "Use the seven letters given to build words and score points.",
    scoreType: "int[3]",
    scorePrompt:"What was your total score?",
    isLocked: true,
  },
  {
    id: 33,
    category: 2,
    name: "Spells Bee",
    url: "https://spellsbee.com/",
    image: "spellbee2.png",
    caption: "Create all the words you can with the letters provided, always using the center letter",
    scoreType: "int[2]",
    scorePrompt:"How many points did you score?",
  },
  {
    id: 34,
    category: 2,
    name: "Combinations",
    url: "https://combinations.org/",
    image: "combinations.png",
    caption: "Create all the words you can by combining the groups of letters provided",
    scoreType: "int[2]",
    scorePrompt:"How many points did you score?",
  },
  {
    id: 35,
    category: 2,
    name: "Quintumble",
    url: "https://quintumble.com/",
    image: "quintumble.png",
    caption: "Swap the letters in a grid to form 5 words",
    scoreType: "int[3]",
    scorePrompt:"How many points did you score?",
  },
  {
    id: 36,
    category: 2,
    name: "Squeezy",
    url: "https://imsqueezy.com/",
    image: "squeezy.png",
    caption: "Insert letters into words to form new words. The inserted letters form a hidden word. After three rounds, guess the hidden theme that connects those three words.",
  },
  {
    id: 37,
    category: 2,
    name: "Word Chase",
    url: "https://wordchase.clevergoat.com/",
    image: "wordchase.png",
    caption: "Connect the letters on a board to make as many words as you can in two minutes",
    scoreType: "int[5]",
    scorePrompt:"How many points did you score?",
  },
  {
    id: 38,
    category: 2,
    name: "Spell Check",
    url: "https://spellcheck.xyz/solo_game",
    image: "spellcheck.png",
    caption: "Spell each of the spoken words correctly to score",
    scoreType: "int[2]",
    scorePrompt:"How many of the 15 words did you spell correctly?",
  },
  {
    id: 39,
    category: 2,
    name: "Blossom",
    url: "https://www.merriam-webster.com/games/blossom-word-game",
    image: "blossom.png",
    caption: "Make the best twelve words you can using a few provided letters",
    scoreType: "int[3]",
    scorePrompt:"What was your total score?",
  },
  {
    id: 40,
    category: 2,
    name: "Word Search",
    url: "https://wordsearch.io/",
    image: "wordsearch.png",
    caption: "Find words in a grid",
  },
  {
    id: 41,
    category: 2,
    name: "One Word Search",
    url: "https://puzzlist.com/onewordsearch/",
    image: "onewordsearch.png",
    caption: "Race to find words, one at a time, in a 5x5 grid",
    scoreType: "time",
    scorePrompt:"How long did it take?",
  },
  {
    id: 42,
    category: 2,
    name: "Stack Down",
    url: "https://puzzlist.com/stackdown/",
    image: "stackdown.png",
    caption: "Remove tiles to reveal the tiles under them and spell 5-letter words",
    scoreType: "time",
    scorePrompt:"How long did it take (with no hints)?",
  },
  {
    id: 43,
    category: 2,
    name: "Scrabble",
    url: "https://playscrabble.com/",
    image: "scrabble.png",
    caption: "Compete by placing letter tiles on the board to build words and score points.",
  },
  {
    id: 44,
    category: 2,
    name: "Wridges",
    url: "https://www.washingtonpost.com/games/wridges/",
    image: "wridges.png",
    caption: "Build words quickly in a hex grid to clear levels and move upwards",
    scoreType: "int[3]",
    scorePrompt:"How many levels did you clear?",
  },
  {
    id: 45,
    category: 2,
    name: "Cyphr",
    url: "https://cyphrgame.com/",
    image: "cyphr.png",
    caption: "Guess the words in a pyramid, based on a cypher",
    scoreType: "int[2]",
    scorePrompt:"How many guesses did you have remaining?",
  },
  {
    id: 46,
    category: 2,
    name: "Decipher",
    url: "https://decipher.wtf/",
    image: "decipher.png",
    caption: "Solve a cryptogram, filling in the letters to form a quotation",
    scoreType: "int[1]",
    scorePrompt:"How many stars did you earn?",
  },
  {
    id: 47,
    category: 3,
    name: "Wordle",
    url: "https://www.nytimes.com/games/wordle/index.html",
    image: "wordle.png",
    caption: "Guess words and deduce a target 5-letter word based on which letters are correct.",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did you need?",
  },
  {
    id: 48,
    category: 3,
    name: "Dordle",
    url: "https://dordlewordle.com/",
    image: "dordle.png",
    caption: "Like Wordle, but instead guess words and deduce two target 5-letter words simultaneously.",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did you need?",
  },
  {
    id: 49,
    category: 3,
    name: "Quordle",
    url: "https://www.quordle.com/",
    image: "quordle.png",
    caption: "Like Wordle, but instead guess words and deduce four target 5-letter words simultaneously.",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did you need?",
  },
  {
    id: 50,
    category: 3,
    name: "Duotrigordle",
    url: "https://duotrigordle.com/",
    image: "duotrigordle.png",
    caption: "Guess 32 simultaneous words using Wordle-style clues.",
    scoreType: "int[2]",
    scorePrompt:"How many guesses did it take?",
  },
  {
    id: 51,
    category: 3,
    name: "Absurdle",
    url: "https://qntm.org/files/absurdle/absurdle.html",
    image: "absurdle.png",
    caption: "Wordle, but it eludes you by changing the word until there's just one option left.",
  },
  {
    id: 52,
    category: 3,
    name: "Xordle",
    url: "https://xordle.xyz/",
    image: "xordle.png",
    caption: "Solve a Wordle puzzle with two words together. Each clue could apply to either of the words.",
    scoreType: "int[1]",
    scorePrompt:"How many guesses (excluding the first clue)?",
  },
  {
    id: 53,
    category: 3,
    name: "Hurdle",
    url: "https://playhurdle.vercel.app/",
    image: "hurdle.png",
    caption: "Wordle, with vague clues that describe the number of matches, but not their positions.",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did it take?",
  },
  {
    id: 54,
    category: 3,
    name: "Crosswordle",
    url: "https://crosswordle.serializer.ca/",
    image: "crosswordle2.png",
    caption: "Guess a small crossword, based on which letters are correct, or in the wrong place.",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did it take?",
  },
  {
    id: 55,
    category: 3,
    name: "Adverswordle",
    url: "https://adverswordle.doteye.online/",
    image: "adverswordle.png",
    caption: "Wordle in reverse. An AI guesses and you have to keep changing the word as long as possible.",
    scoreType: "int[1]",
    scorePrompt:"How many turns did you last?",
  },
  {
    id: 56,
    category: 3,
    name: "Victordle",
    url: "https://www.britannica.com/games/victordle/",
    image: "cowordle.png",
    caption: "Play Wordle agianst an opponent, either turn-by-turn or side-by side.",
  },
  {
    id: 57,
    category: 3,
    name: "Pixletters",
    url: "https://pixletters.com/",
    image: "pixletters.png",
    caption: "Guess a word with Wordle-style clues about the individual pixels in each letter.",
    scoreType: "int[1]",
    scorePrompt:"How many guesses on the regular puzzle (not plus or pro)",
  },
  {
    id: 58,
    category: 3,
    name: "Stressfle",
    url: "https://stressfle.nikolaus.uk/",
    image: "stressfle.png",
    caption: "Guess a word with vague Wordle-like clues that don't specify which letters are right.",
    scoreType: "int[2]",
    scorePrompt:"How many guesses did you use?",
  },
  {
    id: 61,
    category: 3,
    name: "Phrazle",
    url: "https://solitaired.com/phrazle",
    image: "phrazle.png",
    caption: "Guess letters in a phrase with Wordle-style clues",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did it take?",
  },
  {
    id: 62,
    category: 3,
    name: "Letroso",
    url: "https://letroso.com/en/daily",
    image: "letroso.png",
    caption: "Guess the word based on clues about the relative positions of letters.",
    scoreType: "int[2]",
    scorePrompt:"How many guesses did you make?",
  },
  {
    id: 63,
    category: 4,
    name: "Numberle",
    url: "https://numberle.org/",
    image: "numberle.png",
    caption: "Guess a mathematical equation using Wordle-style clues.",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did it take?",
  },
  {
    id: 64,
    category: 4,
    name: "Mergetin",
    url: "https://mergetin.com/",
    image: "mergetin.png",
    caption: "Swap the numbered blocks to form groups and clear them. Build combos and score big.",
  },
  {
    id: 65,
    category: 4,
    name: "All Ten",
    url: "https://beastacademy.com/all-ten",
    image: "all10.png",
    caption: "Use each of these numbers in ten expressions, each equaling 1 to 10.",
    scoreType: "int[1-10]",
    scorePrompt:"How many of the 10 expressions did you get?",
  },
  {
    id: 66,
    category: 4,
    name: "Cubisum",
    url: "https://cubisum.com/",
    image: "cubisum.png",
    caption: "Match numbered rectangles",
    scoreType: "int[2]",
    scorePrompt:"How many moves did you take on the easy puzzle?",
  },
  {
    id: 67,
    category: 4,
    name: "Nerdle",
    url: "https://nerdlegame.com/",
    image: "nerdle.png",
    caption: "Guess a math equation with Wordle-style clues",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did you make?",
  },
  {
    id: 68,
    category: 4,
    name: "Numble",
    url: "https://numble.wtf/",
    image: "numble.png",
    caption: "Write a mathematical expression using the numbers and operators to equal the target value",
  },
  {
    id: 69,
    category: 4,
    name: "Sudoku: Easy",
    url: "https://www.nytimes.com/puzzles/sudoku/easy",
    image: "sudokueasy.png",
    caption: "Deduce the numbers in a grid, with the numbers 1-9 in each row, column, and square.",
    scoreType: "time",
    scorePrompt:"How long did it take?",
  },
  {
    id: 70,
    category: 4,
    name: "Sudoku: Medium",
    url: "https://www.nytimes.com/puzzles/sudoku/medium",
    image: "sudokumedium.png",
    caption: "Deduce the numbers in a more challenging grid, with fewer clues provided.",
    scoreType: "time",
    scorePrompt:"How long did it take?",
  },
  {
    id: 71,
    category: 4,
    name: "Sudoku: Hard",
    url: "https://www.nytimes.com/puzzles/sudoku/hard",
    image: "sudokuhard.png",
    caption: "Deduce the numbers in a grid, with very little information. Very difficult!",
    scoreType: "time",
    scorePrompt:"How long did it take?",
  },
  // {
  //   id: 72,
  //   category: 4,
  //   name: "Matchsticks",
  //   url: "https://www.askforgametask.com/html5/games/matchsticks/",
  //   image: "matchsticks.png",
  //   caption: "Move one of the matchsticks to fix the equation that they spell out.",
  // },
  {
    id: 73,
    category: 4,
    name: "Pips - Easy",
    url: "https://www.nytimes.com/games/pips/easy",
    image: "pipseasy.png",
    caption: "Place the dominoes on the board, following all the rules for the colored areas.",
    scoreType: "time",
    scorePrompt:"How long did it take to complete?",
  },
  {
    id: 74,
    category: 4,
    name: "Pips - Medium",
    url: "https://www.nytimes.com/games/pips/medium",
    image: "pipsmedium.png",
    caption: "Place the dominoes on the board, following all the rules for the colored areas.",
    scoreType: "time",
    scorePrompt:"How long did it take to complete?",
  },
  {
    id: 75,
    category: 4,
    name: "Pips - Hard",
    url: "https://www.nytimes.com/games/pips/hard",
    image: "pipshard.png",
    caption: "Place the dominoes on the board, following all the rules for the colored areas.",
    scoreType: "time",
    scorePrompt:"How long did it take to complete?",
  },
  {
    id: 76,
    category: 4,
    name: "Minute Cryptic",
    url: "https://www.minutecryptic.com/",
    image: "minutecryptic.png",
    caption: "Learn how to solve cryptic crosswords one clue at a time",
    scoreType: "int[1]",
    scorePrompt:"How many hints did you use?",
  },
  {
    id: 77,
    category: 4,
    name: "Murdle",
    url: "https://murdle.com/",
    image: "murdle.png",
    caption: "Solve a mystery riddle using logical deduction.",
    scoreType: "bool",
    scorePrompt:"Did you solve the mystery?",
  },
  {
    id: 78,
    category: 4,
    name: "Puzzle Madness",
    url: "https://puzzlemadness.co.uk/",
    image: "puzzlemadness.png",
    caption: "A big collection of sudoku and logic puzzles",
  },
  {
    id: 79,
    category: 4,
    name: "Brain Bashers",
    url: "https://www.brainbashers.com/today.asp",
    image: "brainbashers.png",
    caption: "A huge collection of brain teasers and puzzles",
  },
  {
    id: 80,
    category: 5,
    name: "Hocus Focus",
    url: "https://hocusfocus.nicelight.games/",
    image: "hocus.png",
    caption: "The pixel-painting picture puzzle. Swipe around to reveal the image, then click the target.",
    scoreType: "int[1]",
    scorePrompt:"How many stars did you get?",
    isLinked:1,
  },
  {
    id: 81,
    category: 5,
    name: "Colorfle",
    url: "https://colorfle.com/",
    image: "colorfle.png",
    caption: "Choose the right colors in the right proportion to blend to get the target color",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did you use?",
  },
  {
    id: 82,
    category: 5,
    name: "Tiles",
    url: "https://www.nytimes.com/puzzles/tiles",
    image: "tiles.png",
    caption: "Match tiles by common design elements and keep your chain going.",
    scoreType: "int[2]",
    scorePrompt:"What was your longest combo?",
    isLocked: true,
  },
  {
    id: 83,
    category: 5,
    name: "Entanglement",
    url: "http://entanglement.gopherwoodstudios.com/en-US-index.html",
    image: "entanglement.png",
    caption: "Build a path with hex tiles in this strategy board game.",
  },
  {
    id: 84,
    category: 5,
    name: "Nonograms",
    url: "https://www.puzzle-nonograms.com/",
    image: "nonograms.png",
    caption: "Color the pixels of a grid based on the number of that color in each row and column.",
    scoreType: "time",
    scorePrompt:"How long did the 5x5 puzzle take?",
  },
  {
    id: 85,
    category: 5,
    name: "Linkr",
    url: "https://www.playlinkr.net/",
    image: "linkr.png",
    caption: "A spatial puzzle where you connect all the dots within the shape provided.",
    scoreType: "time",
    scorePrompt:"How long did it take on the three-star puzzle?",
  },
  {
    id: 86,
    category: 5,
    name: "Encase",
    url: "https://thexp.itch.io/encase",
    image: "encase.png",
    caption: "Spin the lines to make triangles in this spatial challenge.",
  },
  {
    id: 87,
    category: 5,
    name: "Figure",
    url: "https://figure.game/",
    image: "figure.png",
    caption: "Clear colored groups of blocks from the bottom. You have 9 moves to clear all of them.",
    scoreType: "int[2]",
    scorePrompt:"How many tries did it take you?",
  },
  {
    id: 88,
    category: 5,
    name: "Polygonle",
    url: "https://polygonle.com/",
    image: "polygonle.png",
    caption: "Solve a Wordle-like puzzle starting with a shape-based cypher.",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did it take?",
  },
  {
    id: 89,
    category: 5,
    name: "Unlockle",
    url: "https://unlockle.app/",
    image: "unlockle.png",
    caption: "Guess the number pad unlock pattern, using Wordle-style clues.",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did it take?",
  },
  {
    id: 90,
    category: 5,
    name: "Spots",
    url: "https://spots.wtf/",
    image: "spots.png",
    caption: "Guess the combination of four dots, each in one of six colors. After each guess, get clues about which are correct",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did you use?",
  },
  {
    id: 91,
    category: 5,
    name: "Celtix",
    url: "https://www.andrewt.net/puzzles/celtix/",
    image: "celtix.png",
    caption: "Click on the overlapping cords of a giant celtic knot to form paths that connect the dots",
    scoreType: "int[2]",
    scorePrompt:"How many walls did you use to solve the puzzle?",
  },
  {
    id: 92,
    category: 5,
    name: "2048",
    url: "https://play2048.co/",
    image: "2048.png",
    caption: "Match powers of two to make them combine into a larger number and clear space to keep going.",
  },
  {
    id: 93,
    category: 5,
    name: "Matle",
    url: "http://matle.io/",
    image: "matle.png",
    caption: "Deduce a specific chessboard state with a checkmate, using Wordle-style hints",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did you use?",
  },
  {
    id: 94,
    category: 5,
    name: "Chessle",
    url: "https://jackli.gg/chessle/",
    image: "chessle.png",
    caption: "Guess the opening moves of a chess game, with Wordle-style clues",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did you make?",
  },
  {
    id: 95,
    category: 5,
    name: "Fortknight",
    url: "https://acenturyandabit.github.io/fortknight/",
    image: "fortknight.png",
    caption: "Use your knight to survive and take pieces in this chess battle puzzle.",
  },
  {
    id: 96,
    category: 6,
    name: "Worldle",
    url: "https://worldle.teuteuf.fr/",
    image: "worldle.png",
    caption: "Guess a country based on its shape and clues about its distance from each guess.",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did it take?",
  },
  {
    id: 97,
    category: 6,
    name: "Tradle",
    url: "https://oec.world/en/tradle/",
    image: "tradle.png",
    caption: "Guess a country based on its export statistics and distance clues.",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did it take?",
  },
  {
    id: 98,
    category: 6,
    name: "Globle",
    url: "https://globle-game.com/game",
    image: "globle.png",
    caption: "Find a country on the globe, with clues based on distance from previous guesses.",
  },
  {
    id: 99,
    category: 6,
    name: "TimeGuessr",
    url: "https://timeguessr.com",
    image: "timeguessr.png",
    caption: "Guess the time & place of a photo",
    scoreType: "int[2]",
    scorePrompt:"Enter your score, divided by 1000.",
  },
  {
    id: 100,
    category: 6,
    name: "Travle",
    url: "https://travle.earth/",
    image: "travle.png",
    caption: "Find all the countries in between two countries",
    scoreType: "int[2]",
    scorePrompt:"How many guesses did you make?",
  },
  {
    id: 101,
    category: 6,
    name: "Statele",
    url: "https://statele.teuteuf.fr/",
    image: "statle.png",
    caption: "Guess the US state based on its shape and distance from previous guesses.",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did you make?",
  },
  {
    id: 102,
    category: 6,
    name: "WhereTaken USA",
    url: "https://wheretakenusa.teuteuf.fr/",
    image: "wheretakenusa.png",
    caption: "Guess a US location based on a series of photos",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did you make?",
  },
  {
    id: 103,
    category: 6,
    name: "WhereTaken",
    url: "https://wheretaken.com/game",
    image: "wheretaken.png",
    caption: "Guess the geographic location of each of a series of photos",
    scoreType: "int[3]",
    scorePrompt:"What was your total score for all five rounds",
  },
  {
    id: 104,
    category: 6,
    name: "Flagle",
    url: "https://www.flagle.io/",
    image: "flagle.png",
    caption: "Guess the flag as it is revealed section by section, with hints based on distance.",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did it take you?",
  },
  {
    id: 105,
    category: 6,
    name: "MapGame",
    url: "https://mapgame.net/",
    image: "mapgame.png",
    caption: "Guess a country with clues",
    scoreType: "int[1]",
    scorePrompt:"How many hearts did you have remaining?",
  },
  {
    id: 106,
    category: 6,
    name: "FoodGuessr",
    url: "https://www.foodguessr.com/game/daily",
    image: "foodguessr.png",
    caption: "Guess where a dish comes from, based on image, ingredients, and geographic clues",
    scoreType: "int[2]",
    scorePrompt:"How many points did you score (divided by 1000)?",
  },
  {
    id: 107,
    category: 7,
    name: "Framed",
    url: "https://framed.wtf/",
    image: "framed.png",
    caption: "Guess a movie from a series of still frames.",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did it take?",
  },
  {
    id: 108,
    category: 7,
    name: "Emovie",
    url: "https://emovi.teuteuf.fr/",
    image: "emovi.png",
    caption: "Guess a movie from a clue that contains only emojis.",
    scoreType: "int[1]",
    scorePrompt:"How many guesses/hints did it take?",
  },
  {
    id: 109,
    category: 7,
    name: "Box Office Game",
    url: "https://boxofficega.me/",
    image: "boxoffice.png",
    caption: "Guess the top movies from a weekend by choosing the clues you want about each film.",
    scoreType: "int[4]",
    scorePrompt:"What was your total score, out of 1000?",
  },
  {
    id: 110,
    category: 7,
    name: "Cine2Nerdle",
    url: "https://www.cinenerdle.app/",
    image: "cine2nerdle.png",
    caption: "Move movie clues around a grid and line them up to reveal the movies.",
    scoreType: "int[1]",
    scorePrompt:"How many moves were remaining?",
  },
  {
    id: 111,
    category: 7,
    name: "Gaps",
    url: "https://gaps.wtf/",
    image: "gaps.png",
    caption: "Guess the name of the movie using the clues provided after each guess",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did you use?",
  },
  {
    id: 112,
    category: 7,
    name: "Guess The Movie",
    url: "https://guessthemovie.name/",
    image: "guessthemovie.png",
    caption: "Guess a movie from a series of still images and clues.",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did you use?",
  },
  {
    id: 113,
    category: 7,
    name: "Plot Words",
    url: "https://plotwords.com/daily",
    image: "plotwords.png",
    caption: "Guess the name of the movie using as few plot keywords as possible",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did you use?",
  },
  {
    id: 114,
    category: 7,
    name: "Actorle",
    url: "https://actorle.com/fill-the-grid/",
    image: "actorle.png",
    caption: "Fill a 3x3 grid with actors that match both the column and row clues",
    scoreType: "int[2]",
    scorePrompt:"How many guesses did you take (out of 16)?",
  },
  {
    id: 115,
    category: 7,
    name: "Episode",
    url: "https://episode.wtf/",
    image: "episode.png",
    caption: "Guess a TV show based on a series of stills",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did it take you?",
  },
  {
    id: 116,
    category: 7,
    name: "Guess The Audio",
    url: "https://guesstheaudio.com/",
    image: "guesstheaudio.png",
    caption: "Identify the song by listening to an audio clip.",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did you use?",
  },
  {
    id: 117,
    category: 7,
    name: "Bandle",
    url: "https://bandle.app/daily",
    image: "bandle.png",
    caption: "Guess a song based on some facts about it and listening to different instrumental parts",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did you make?",
    isLinked:1,
  },
  {
    id: 118,
    category: 7,
    name: "Spotle",
    url: "https://spotle.io/",
    image: "spotle.png",
    caption: "Guess an artist or band based on similar facts to each of your guesses",
    scoreType: "int[2]",
    scorePrompt:"How many points did you score?",
  },
  {
    id: 119,
    category: 7,
    name: "Gamedle",
    url: "https://www.gamedle.wtf/?lang=en",
    image: "gamedle.png",
    caption: "Guess a video game based on a image that gets revealed.",
    scoreType: "int[1]",
    scorePrompt:"How many hearts remaining (in classic mode)?",
  },
  {
    id: 120,
    category: 7,
    name: "Guess The Game",
    url: "https://guessthe.game/",
    image: "guessthegame.png",
    caption: "Identify a video game based on a series of screenshots",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did you use?",
  },
  {
    id: 121,
    category: 7,
    name: "loldle",
    url: "https://loldle.net/",
    image: "loldle.png",
    caption: "Guess a League of Legends champion based on clues about its traits.",
    scoreType: "int[2]",
    scorePrompt:"How many guesses did it take (in Classic Mode)?",
  },
  {
    id: 122,
    category: 7,
    name: "Smashdle",
    url: "https://smashdle.net/",
    image: "smashdle.png",
    caption: "Guess the character from Super Smash Bros. based on similar traits with previous guesses",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did you use?",
  },
  {
    id: 123,
    category: 7,
    name: "Pokedle",
    url: "https://pokedle.net/",
    image: "pokedle.png",
    caption: "Guess the Pokemon, based on similar traits with previous guesses",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did you use?",
  },
  {
    id: 124,
    category: 7,
    name: "Dungleon",
    url: "https://www.dungleon.com/",
    image: "dungleon.png",
    caption: "Guess the series of RPG-themed icons based on special dungeon rules and Wordle-style clues",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did you use?",
  },
  {
    id: 125,
    category: 7,
    name: "Guess The Logo",
    url: "https://guessthelogo.wtf/",
    image: "guessthelogo.png",
    caption: "Identify a logo as it's revealed, section by section",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did you use?",
  },
  {
    id: 126,
    category: 7,
    name: "Walk Off",
    url: "https://www.dailywalkoff.com/",
    image: "walkoff.png",
    caption: "Put each baseball player in the correct trivia column to score and avoid getting outs",
  },
  {
    id: 127,
    category: 8,
    name: "Trivia V",
    url: "https://triviav.com/",
    image: "triviav.png",
    caption: "Answer five general trivia questions. New questions arrive every Monday.",
    scoreType: "int[1]",
    scorePrompt:"How many did you get right?",
  },
  {
    id: 128,
    category: 8,
    name: "Metazooa",
    url: "https://metazooa.com/play/game",
    image: "metazooa.png",
    caption: "Guess an animal based on clues about that animal's relationship with the ones you've guessed.",
    scoreType: "int[2]",
    scorePrompt:"How many guesses did you have remaining?",
  },
  {
    id: 129,
    category: 8,
    name: "Metaflora",
    url: "https://flora.metazooa.com/",
    image: "metaflora.png",
    caption: "Guess an plant based on clues about its relationship with the ones you've guessed.",
    scoreType: "int[2]",
    scorePrompt:"How many guesses did you have remaining?",
  },
  {
    id: 130,
    category: 8,
    name: "Real Bird Fake Bird",
    url: "http://realbirdfakebird.com/",
    image: "realbird.png",
    caption: "For seven items in a category, guess if each one is real or a clever fake",
    scoreType: "int[1]",
    scorePrompt:"How many did you guess correctly?",
  },
  {
    id: 131,
    category: 8,
    name: "The Wiki Game",
    url: "https://www.thewikigame.com",
    image: "wikigame.png",
    caption: "Race to go from one Wikipedia page to another, link by link.",
  },
  {
    id: 132,
    category: 8,
    name: "Catfishing",
    url: "https://catfishing.net/game/today",
    image: "catfishing.png",
    caption: "Guess ten Wikipedia articles, each based on its list of keywords",
    scoreType: "int[2]",
    scorePrompt:"How many did you get right?",
  },
  {
    id: 133,
    category: 8,
    name: "Artle",
    url: "https://www.nga.gov/artle.html",
    image: "artle.png",
    caption: "Guess a visual artist based on samples of their work.",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did it take?",
  },
  {
    id: 134,
    category: 8,
    name: "Housle",
    url: "https://housle.house/",
    image: "housle.png",
    caption: "Guess the price of a house based on photos and higher-lower clues",
    scoreType: "int[2]",
    scorePrompt:"What percent from the exact price (rounded to a whole number)?",
  },
  {
    id: 135,
    category: 9,
    name: "Quick Draw",
    url: "https://quickdraw.withgoogle.com/",
    image: "quickdraw.png",
    caption: "Doodle pictures and help an A.I. guess what you're drawing as soon as possible.",
  },
  {
    id: 136,
    category: 9,
    name: "Line Rider",
    url: "https://www.linerider.com/",
    image: "linerider.png",
    caption: "Draw the path for a snowmobile to race across, and try not to crash.",
  },
  {
    id: 137,
    category: 9,
    name: "Slither",
    url: "http://slither.io/",
    image: "slither.png",
    caption: "Guide your snake, eat and grow, and avoid other players' snakes... or trap them!",
  },
  // {
  //   id: 138,
  //   category: 9,
  //   name: "Snake Runner",
  //   url: "http://www.askforgametask.com/html5/games/snake/",
  //   image: "snakerunner.png",
  //   caption: "Control the snake to avoid obstacles as you move through the scrolling level.",
  // },
  {
    id: 139,
    category: 9,
    name: "Solitaire",
    url: "https://solitaire.online/",
    image: "solitaire.png",
    caption: "Play classic solitaire games like Klondike or Spider.",
  },
  {
    id: 140,
    category: 9,
    name: "Sand Spiel",
    url: "https://sandspiel.club/",
    image: "sandspiel.png",
    caption: "Add a variety of particles to this physics sandbox and see what happens.",
  },
  {
    id: 141,
    category: 9,
    name: "Bubble Shooter",
    url: "https://games.washingtonpost.com/en-us/games/bubble-shooter",
    image: "bubbleshooter.png",
    caption: "Launch bubbles, connect colors to pop them, and clear the stage",
  },
  {
    id: 142,
    category: 9,
    name: "Forgeous",
    url: "https://forgeous.fun/game/Q19912013",
    image: "forgeous.png",
    caption: "Quickly fingerpaint a piece of art. How close can you get to the original?",
    scoreType: "int[2]",
    scorePrompt:"How close was your painting (in percent)?",
  },
  {
    id: 143,
    category: 9,
    name: "Gridland",
    url: "http://gridland.doublespeakgames.com/",
    image: "gridland.png",
    caption: "Swap tiles in a grid to match three in a row, with an adventurous theme",
  },
  {
    id: 144,
    category: 9,
    name: "What Beats Rock",
    url: "https://www.whatbeatsrock.com/",
    image: "whatbeatsrock.png",
    caption: "Play imaginative battles and see which one wins, as judged by an AI",
  },
  {
    id: 145,
    category: 5,
    name: "Stars",
    url: "https://inkwellgames.com/games/stars",
    image: "stars.png",
    caption: "Find the stars in the grid based on the rules about the placement",
    scoreType: "time",
    scorePrompt:"How long did it take to complete?",
  },
  {
    id: 146,
    category: 5,
    name: "Fields",
    url: "https://inkwellgames.com/games/fields",
    image: "fields.png",
    caption: "Group squares by color based on the sizes provided in some squares",
    scoreType: "time",
    scorePrompt:"How long did it take to complete?",
  },
  {
    id: 147,
    category: 2,
    name: "Pair Down",
    url: "https://pairdown.com/",
    image: "pairdown.png",
    caption: "Find the letters to omit from each of the words, which combine to form the solution words.",
    scoreType: "int[2]",
    scorePrompt:"How many stars did you get total, on hard mode?",
  },

  {
    id: 148,
    category: 2,
    name: "Foximax",
    url: "https://foximax.com/",
    image: "foximax.png",
    caption: "Guess words, one letter at a time",
    scoreType: "int[1]",
    scorePrompt:"How many words did you reveal?",
  },
  {
    id: 149,
    category: 8,
    name: "Rankle",
    url: "https://www.rankle.app/",
    image: "rankle.png",
    caption: "Rank the six items in order, with four guesses",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did you use?",
  },
  {
    id: 150,
    category: 2,
    name: "Llamagrama",
    url: "https://www.llamagrama.com/game",
    image: "llamagrama.png",
    caption: "Arrange the letters to form increasingly long words",
    // scoreType: "int[1]",
    // scorePrompt:"What was your score?",
  },
  {
    id: 151,
    category: 1,
    name: "Quintalist",
    url: "https://www.quintalist.com/",
    image: "quintalist.png",
    caption: "Select all of the top five options for the specified category",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did you use?",
  },
  {
    id: 152,
    category: 2,
    name: "Scale",
    url: "https://scalewordgame.com/",
    image: "scale.png",
    caption: "Guess increasingly long words",
    // scoreType: "int[1]",
    // scorePrompt:"What was your score?",
  },
  {
    id: 153,
    category: 1,
    name: "Pangramble",
    url: "https://pangramble.com/",
    image: "pangramble.png",
    caption: "Create a short pangram using the three words provided",
    scoreType: "int[2]",
    scorePrompt:"What was your score?",
  },
  {
    id: 154,
    category: 9,
    name: "Hearoglyphics",
    url: "https://hearoglyphics.com/?utm_source=outside_hosting&utm_medium=nicelightgames&utm_campaign=early_growth_trials&utm_content=none&utm_term=none",
    image: "hearoglyphics.png",
    caption: "Deduce the phrases by choosing combinations of phonetic glyphs",
    scoreType: "time",
    scorePrompt:"What was your time (to score 100)?",
  },
  {
    id: 155,
    category: 1,
    name: "Crosswordle",
    url: "https://crosswordle.org/",
    image: "crosswordle3.png",
    caption: "Fill in a crossword using Wordle-style clues",
    scoreType: "int[2]",
    scorePrompt:"How many guesses did you use?",
  },
  {
    id: 156,
    category: 4,
    name: "Tally",
    url: "https://tally-game.com/",
    image: "tally.png",
    caption: "Connect groups of up to 4 numbers that sum up to 10",
    scoreType: "int[1]",
    scorePrompt:"How many mistakes did you make?",
  },
  {
    id: 157,
    category: 8,
    name: "Chronoodle",
    url: "https://chronoodle.com/",
    image: "chronoodle.png",
    caption: "Put seven historical moments in the right order",
    scoreType: "int[1]",
    scorePrompt:"How many correct answers did you get?",
  },
  {
    id: 158,
    category: 1,
    name: "Decodex",
    url: "https://www.playdecodex.com/",
    image: "decodex.png",
    caption: "Decrypt the quote by guessing the letters",
    scoreType: "int[1]",
    scorePrompt:"How many hints did you use?",
  },
  {
    id: 159,
    category: 2,
    name: "Wordiply",
    url: "https://www.wordiply.com/",
    image: "wordiply.png",
    caption: "Create five long words that each include the starter word",
    scoreType: "int[2]",
    scorePrompt:"How many letters did you use in your five words?",
  },
  {
    id: 160,
    category: 4,
    name: "Buzzled",
    url: "https://puzzmallow.com/buzzled",
    image: "buzzled.png",
    caption: "Color the hexagons to get the right total for each row",
    scoreType: "time",
    scorePrompt:"How long did you take to solve the Classic puzzle?",
  },
  // {
  //   id: 161,
  //   category: 1,
  //   name: "WordWise",
  //   url: "https://www.wordwise.fyi/",
  //   image: "wordwise.png",
  //   caption: "Guess the words based on the definitions provided",
  //   scoreType: "int[1]",
  //   scorePrompt:"How many did you get in one guess (green boxes)?",
  //   isNew:true,
  // },
  {
    id: 162,
    category: 9,
    name: "Morsle",
    url: "https://morsle.fun/",
    image: "morsle.png",
    caption: "Guess the word based on audible morse code",
    scoreType: "int[2]",
    scorePrompt:"What WPM score did you get?",
  },
  {
    id: 163,
    category: 6,
    name: "MapTap",
    url: "https://maptap.gg/",
    image: "maptap.png",
    caption: "Cick on a globe as close as possible to the cities provided",
    scoreType: "int[4]",
    scorePrompt:"What was your score?",
  },
  {
    id: 164,
    category: 8,
    name: "ChronoPhoto",
    url: "https://www.chronophoto.app/daily.html",
    image: "chronophoto.png",
    caption: "Guess the year that each photo was taken",
    scoreType: "int[4]",
    scorePrompt:"What was your score?",
  },
  {
    id: 165,
    category: 4,
    name: "Bells & Whistles",
    url: "https://puzzmallow.com/bells",
    image: "bellsandwhistles.png",
    caption: "Fill the grid with bells and whistles based on the row and column clues",
    scoreType: "time",
    scorePrompt:"What was your time to complete the Classic puzzle?",
  },
  {
    id: 166,
    category: 1,
    name: "Wordsmyth",
    url: "https://playwordsmyth.com",
    image: "wordsmyth.png",
    caption: "Transform each word into the next word based on the clues",
    scoreType: "time",
    scorePrompt:"What was your final time score in competitive mode?",
  },
  {
    id: 167,
    category: 6,
    name: "WhichWay",
    url: "https://whichway.is",
    image: "whichway.png",
    caption: "Point in the direction to the next country",
    scoreType: "int[3]",
    scorePrompt:"What was your total score?",
  },
  // {
  //   id: 168,
  //   category: 2,
  //   name: "Jumble",
  //   url: "https://fun.chicagotribune.com/game/tca-jumble-daily",
  //   image: "jumble.png",
  //   caption: "Rearrange the letters in each word, then combine the seleted letters to reveal the punchline",
  //   scoreType: "int[]",
  //   scorePrompt:"What was your score?",
  //   isNew:true,
  // },
  {
    id: 169,
    category: 8,
    name: "Graphs",
    url: "https://www.graphs.gg/",
    image: "graphs.png",
    caption: "Guess which dataset is represented by the graph",
    scoreType: "int[1]",
    scorePrompt:"How many tries did it take you?",
  },
  {
    id: 170,
    category: 7,
    name: "Cineline",
    url: "https://www.playcineline.com/",
    image: "cineline.png",
    caption: "Place movies in chronological order on the timeline based on their release year",
    scoreType: "int[1]",
    scorePrompt:"How many perfect placements (green circles)?",
  },
  {
    id: 171,
    category: 5,
    name: "ColorGuesser",
    url: "https://colorguesser.com/",
    image: "colorguesser.png",
    caption: "Guess each color using a color picker, based on its name",
    scoreType: "int[3]",
    scorePrompt:"What was your final score (out of 500)?",
  },
  {
    id: 172,
    category: 1,
    name: "Redactle",
    url: "https://redactle.net/",
    image: "redactle2.png",
    caption: "Guess the words that have been edited from a Wikipedia article",
    scoreType: "int[3]",
    scorePrompt:"How many guesses did you use (with no hints)?",
  },
  {
    id: 173,
    category: 1,
    name: "Crossclimb",
    url: "https://www.linkedin.com/games/crossclimb",
    image: "crossclimb.png",
    caption: "Guess a series of words, each different by one letter, based on the clues",
    scoreType: "time",
    scorePrompt:"How much time did it take to solve?",
  },
  {
    id: 174,
    category: 5,
    name: "I'm Not a Robot",
    url: "https://neal.fun/not-a-robot",
    image: "notarobot.png",
    caption: "A series of increasingly absurd Captcha-style tests",
  },
  {
    id: 175,
    category: 8,
    name: "Venn Puzzle",
    url: "https://www.vennpuzzle.com/",
    image: "vennpuzzle.png",
    caption: "Fill in a Venn Diagram for interrelated items",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did it take?",
  },
  {
    id: 176,
    category: 1,
    name: "Silly Little Codes",
    url: "https://www.playsillylittlegames.com/codes",
    image: "sillylittlecodes.png",
    caption: "Solve the daily rebus puzzle",
    scoreType: "time",
    scorePrompt:"How long did it take?",
  },
  {
    id: 177,
    category: 1,
    name: "Wordhuntle",
    url: "https://www.wordhuntle.com/",
    image: "wordhuntle.png",
    caption: "Connect letters on the grid to make words and score points",
    scoreType: "int[2]",
    scorePrompt:"How many words did you find?",
  },
  {
    id: 178,
    category: 1,
    name: "Wrodeo",
    url: "https://wrodeo.com",
    image: "wrodeo.png",
    caption: "Guess a literary quotation with letters missing from all the words",
    scoreType: "int[3]",
    scorePrompt:"What was your correct ratio (with no hints)?",
  },
  {
    id: 179,
    category: 5,
    name: "Akari",
    url: "https://dailyakari.com/",
    image: "akari.png",
    caption: "Color lines on the grid to fill the grid satisfy rules in blocks",
    scoreType: "time",
    scorePrompt:"How long did it take you to complete?",
    isLinked:1,
  },
  {
    id: 180,
    category: 5,
    name: "Loop",
    url: "https://dailyloop.app/loop",
    image: "loop.png",
    caption: "Rotate the tiles to form one connected, circular path",
    scoreType: "time",
    scorePrompt:"How long did it take you to complete?",
  },
  {
    id: 181,
    category: 5,
    name: "Branch",
    url: "https://dailyloop.app/branch",
    image: "branch.png",
    caption: "Rotate the tiles so every pipe segment connects to the source, with no dangling ends",
    scoreType: "time",
    scorePrompt:"How long did it take you to complete?",
  },
  // {
  //   id: 182,
  //   category: 2,
  //   name: "Poople",
  //   url: "https://poople.io/",
  //   image: "poople.png",
  //   caption: "Transform a word into the target word, POOP, by changing one letter at a time",
  //   scoreType: "int[1]",
  //   scorePrompt:"What was your score?",
  //   isNew:true,
  // },
  {
    id: 183,
    category: 6,
    name: "Neighborle",
    url: "https://neighborle.com/",
    image: "neighborle.png",
    caption: "Name the countries that border the given country",
    scoreType: "int[1]",
    scorePrompt:"How many neighbors did you guess?",
  },
  {
    id: 184,
    category: 5,
    name: "Echo Chess: Classic",
    url: "https://echochess.com/game?game_mode=DAILY&level_type=CLASSIC",
    image: "echochess.png",
    caption: "Take all the opposing chess pieces. Transform into each piece taken.",
    scoreType: "int[1]",
    scorePrompt:"What was your score?",
  },
  {
    id: 185,
    category: 5,
    name: "Echo Chess: Epic",
    url: "https://echochess.com/game?game_mode=DAILY&level_type=EPIC",
    image: "echochess2.png",
    caption: "Take all the opposing chess pieces. Transform into each piece taken.",
    scoreType: "int[1]",
    scorePrompt:"What was your score?",
  },
  {
    id: 186,
    category: 5,
    name: "Wantedle",
    url: "https://wantedle.com/",
    image: "wantedle.png",
    caption: "Click on the target picture in a chaotic mess of moving pictures",
    scoreType: "time",
    scorePrompt:"How long did you take?",
  },
  {
    id: 187,
    category: 5,
    name: "Spot the Differences",
    url: "https://www.spot-differences.com/",
    image: "spotthedifferences.png",
    caption: "Find the differences between two images",
    scoreType: "int[2]",
    scorePrompt:"How many did you find?",
  },
  {
    id: 188,
    category: 2,
    name: "Couplit",
    url: "https://couplit.io/",
    image: "couplit.png",
    caption: "Move the letters around to form a two-word phrase",
    // scoreType: "int[1]",
    // scorePrompt:"WHow many moves did you take (without using any hints)?",
  },

  {
    id: 189,
    category: 5,
    name: "0h n0",
    url: "https://0hn0.com/",
    image: "0hn0.png",
    caption: "Deduce the dot colors based on neighbors' sight lines",
    scoreType: "int[3]",
    scorePrompt:"What was your score?",
    isNew:true,
  },
  {
    id: 190,
    category: 2,
    name: "18 Words",
    url: "https://18words.com/",
    image: "18words.png",
    caption: "Unscramble a series of words within the time limit",
    scoreType: "int[2]",
    scorePrompt:"How many of the words did you get?",
    isNew:true,
  },
  {
    id: 191,
    category: 1,
    name: "4 × 3",
    url: "https://www.hankgreen.com/fourbythree",
    image: "4x3.png",
    caption: "Four categories. Three words each. One word is in all four.",
    scoreType: "int[3]",
    scorePrompt:"How many points did you score?",
    isNew:true,
  },
  {
    id: 192,
    category: 9,
    name: "AITA Guesser",
    url: "https://muhashi.com/aita-guesser/",
    image: "aitaguesser.png",
    caption: "Cast a moral judgment on a stranger's personal life",
    scoreType: "int[1]",
    scorePrompt:"How many did you guess correctly?",
    isNew:true,
  },
  {
    id: 193,
    category: 3,
    name: "Beeswax",
    url: "https://spellbeeswax.com/",
    image: "beeswax.png",
    caption: "A five word spelling bee",
    scoreType: "int[4]",
    scorePrompt:"How many points did you earn?",
    isNew:true,
  },
  {
    id: 194,
    category: 5,
    name: "Blinkle",
    url: "https://blinklegame.com/",
    image: "blinkle.png",
    caption: "Remember a photo and recall one detail",
    scoreType: "int[4]",
    scorePrompt:"How many points did you earn?",
    isNew:true,
  },
  {
    id: 195,
    category: 8,
    name: "BookIdle",
    url: "https://bookidle.com/daily-cover/",
    image: "bookidle.png",
    caption: "Guess the book cover as it gets clearer",
    scoreType: "int[1]",
    scorePrompt:"How many tries did you take?",
    isNew:true,
  },
  {
    id: 196,
    category: 1,
    name: "Mini Crossword",
    url: "https://www.bostonglobe.com/games/mini-crossword/",
    image: "bostonglobemini.png",
    caption: "Boston's baby crossword.",
    scoreType: "time",
    scorePrompt:"How long did you take?",
    isNew:true,
  },
  {
    id: 197,
    category: 1,
    name: "Broken Words",
    url: "https://www.brokenwords.com/",
    image: "brokenwords.png",
    caption: "Combine word parts to solve the clues",
    scoreType: "int[1]",
    scorePrompt:"How many variants did you solve?",
    isNew:true,
  },
  {
    id: 198,
    category: 1,
    name: "Cadgy",
    url: "https://www.onelook.com/cadgy/",
    image: "cadgy.png",
    caption: "Spell the words, using one letter from each column",
    scoreType: "int[4]",
    scorePrompt:"What was your final score?",
    isNew:true,
  },
  {
    id: 199,
    category: 6,
    name: "Cartology",
    url: "https://cartologygame.com",
    image: "cartology.png",
    caption: "Aim an arrow from one city to hit a second city",
    isNew:true,
  },
  {
    id: 200,
    category: 3,
    name: "Cascadle",
    url: "https://cascadle.xyz/",
    image: "cascadle.png",
    caption: "Guess words of increasing length with clues that carry over",
    scoreType: "int[3]",
    scorePrompt:"How many tiles did you use?",
    isNew:true,
  },
  {
    id: 201,
    category: 1,
    name: "ChainWhich",
    url: "https://chainwhich.com/",
    image: "chainwhich.png",
    caption: "Link words together in a series of pairs",
    scoreType: "time",
    scorePrompt:"Time (with one attempt)",
    isNew:true,
  },
  {
    id: 202,
    category: 7,
    name: "Cinematrix",
    url: "https://www.vulture.com/article/daily-movie-grid-trivia-game-cinematrix.html",
    image: "cinematrix.png",
    caption: "A daily grid game for movie lovers.",
    isNew:true,
  },
  {
    id: 203,
    category: 1,
    name: "Circuits",
    url: "https://www.puzzmo.com/play/circuits",
    image: "circuits.png",
    caption: "Fill in words that create compound words with neighbors",
    scoreType: "int[4]",
    scorePrompt:"What was your score?",
    isNew:true,
  },
  {
    id: 204,
    category: 1,
    name: "ClueDay",
    url: "https://clueday.com/",
    image: "clueday.png",
    caption: "Guess a word with Wordle clues and cryptic hints.",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did you use?",
    isNew:true,
  },
  {
    id: 205,
    category: 1,
    name: "Clueless",
    url: "https://lessgames.com/clueless",
    image: "clueless.png",
    caption: "Guess the word with feedback about its semantic similarity",
    scoreType: "int[2]",
    scorePrompt:"Guesses",
    isNew:true,
  },
  {
    id: 206,
    category: 4,
    name: "Clues by Sam",
    url: "https://cluesbysam.com/",
    image: "cluesbysam.png",
    caption: "Deduce the criminals based on the clues",
    isNew:true,
  },
  {
    id: 207,
    category: 8,
    name: "Collide",
    url: "https://playcollide.com",
    image: "collide.png",
    caption: "Guess all the terms that a short code stands for",
    scoreType: "int[4]",
    scorePrompt:"What was your total score",
    isNew:true,
  },
  {
    id: 209,
    category: 7,
    name: "Crosstune",
    url: "https://crosstune.io",
    image: "crosstune.png",
    caption: "Fill in a crossword based on musical clues",
    scoreType: "time",
    scorePrompt:"How long did you take to complete it?",
    isNew:true,
  },
  {
    id: 210,
    category: 9,
    name: "Curdle",
    url: "https://gumbo.systems/curdle/",
    image: "curdle.png",
    caption: "Guess an obscure cheese from a photo and clues",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did you use?",
    isNew:true,
  },
  {
    id: 211,
    category: 8,
    name: "Daily Tens",
    url: "https://dailytens.com",
    image: "dailytens.png",
    caption: "Guess the top 10 items in a category",
    scoreType: "int[2]",
    scorePrompt:"How many items did you guess?",
    isNew:true,
  },
  {
    id: 212,
    category: 1,
    name: "Dartwords",
    url: "https://www.dartwords.com/",
    image: "dartwords.png",
    caption: "Guess a word with 1-word hints after each guess",
    scoreType: "int[10]",
    scorePrompt:"How many darts did you use?",
    isNew:true,
  },
  {
    id: 213,
    category: 3,
    name: "Don't Wordle",
    url: "https://dontwordle.com/",
    image: "dontwordle.png",
    caption: "Guess without landing on the answer.",
    isNew:true,
  },
  {
    id: 214,
    category: 2,
    name: "Eightile",
    url: "https://eightile.com",
    image: "eightile.png",
    caption: "Unscramble eight words, each adding one new letter.",
    scoreType: "time",
    scorePrompt:"How long did you take?",
    isNew:true,
  },
  {
    id: 215,
    category: 5,
    name: "Enclose.Horse",
    url: "https://enclose.horse/",
    image: "enclosehorse.png",
    caption: "Add walls to enclose the horse in the best area",
    scoreType: "int[3]",
    scorePrompt:"What was your best score?",
    isNew:true,
  },
  {
    id: 216,
    category: 9,
    name: "Estimatle",
    url: "https://estimatle.com",
    image: "estimatle.png",
    caption: "Estimate a series of numeric trivia answers",
    scoreType: "int[3]",
    scorePrompt:"What was your total score?",
    isNew:true,
  },
  {
    id: 217,
    category: 3,
    name: "Extreme Quordle",
    url: "https://www.merriam-webster.com/games/quordle/#/extreme?overlay=extreme-modal-welcome",
    image: "extremequordle.png",
    caption: "Guess one word to test all four grids simultaneously.",
    scoreType: "int[2]",
    scorePrompt:"How many guesses did you use?",
    isNew:true,
  },
  {
    id: 218,
    category: 8,
    name: "Factle",
    url: "https://frontofficesports.com/trivia/factle/",
    image: "factle.png",
    caption: "Rank the top items with Wordle-style clues",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did you take?",
    isNew:true,
  },
  {
    id: 219,
    category: 7,
    name: "FilmLink",
    url: "https://filmlink.io",
    image: "filmlink.png",
    caption: "Connect movies with a series of cast and crew",
    scoreType: "int[2]",
    scorePrompt:"How many links did you use?",
    isNew:true,
  },
  {
    id: 220,
    category: 6,
    name: "GlobeHoppr",
    url: "https://globehoppr.com",
    image: "globehoppr.png",
    caption: "Move from city to city within range to reach the target",
    scoreType: "int[2]",
    scorePrompt:"How many turns did you use?",
    isNew:true,
  },
  {
    id: 221,
    category: 2,
    name: "Glyph",
    url: "https://glyph.today/",
    image: "glyph.png",
    caption: "Decode the hidden word from a stacked glyph.",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did you use?",
    isNew:true,
  },
  {
    id: 222,
    category: 2,
    name: "Gram Jam",
    url: "https://gramjam.app",
    image: "gramjam.png",
    caption: "Swap letters to make words until all tiles are gone",
    scoreType: "int[1]",
    scorePrompt:"How many swaps did you have left for the Mini",
    isNew:true,
  },
  // {
  //   id: 223,
  //   category: 9,
  //   name: "Hexes",
  //   url: "https://threeemojis.com/en-US/play/hexes",
  //   image: "hexes.png",
  //   caption: "Build words from seven letters; center letter required.",
  //   scoreType: "int[2]",
  //   scorePrompt:"Score",
  //   isNew:true,
  // },
  {
    id: 224,
    category: 3,
    name: "Homicidle",
    url: "https://bluequillstudios.com/homicidle/homicidle",
    image: "homicidle.png",
    caption: "Guess a murder scene with Wordle-style clues",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did you use?",
    isNew:true,
  },
  {
    id: 225,
    category: 2,
    name: "Impress",
    url: "https://impress.ink",
    image: "impress.png",
    caption: "Guess the hidden word using a limited set of letter",
    scoreType: "int[3]",
    scorePrompt:"What was your total score?",
    isNew:true,
  },
  {
    id: 226,
    category: 8,
    name: "Krillion",
    url: "https://krillion.io",
    image: "krillion.png",
    caption: "Guess uncommon answers to earn more points",
    scoreType: "int[3]",
    scorePrompt:"What was your score?",
    isNew:true,
  },
  {
    id: 227,
    category: 1,
    name: "Mini Crossword",
    url: "https://www.latimes.com/games/mini-crossword",
    image: "latmini.png",
    caption: "L.A.'s little crossword.",
    scoreType: "time",
    scorePrompt:"How long did you take?",
    isNew:true,
  },
  {
    id: 228,
    category: 2,
    name: "Lettergrams",
    url: "https://puzzlist.com/lettergrams/",
    image: "lettergrams.png",
    caption: "Build words in a grid using a set of letters",
    scoreType: "int[3]",
    scorePrompt:"How many points did you score?",
    isNew:true,
  },
  {
    id: 229,
    category: 7,
    name: "LogoHue",
    url: "https://logohue.app/",
    image: "logohue.png",
    caption: "Guess a brand color with one guess.",
    scoreType: "int[3]",
    scorePrompt:"What percent did you score?",
    isNew:true,
  },
  {
    id: 230,
    category: 5,
    name: "Loopy River",
    url: "https://inkwellgames.com/games/loopy-river",
    image: "loopyriver.png",
    caption: "Draw a river that flows in a loop through every tile",
    scoreType: "time",
    scorePrompt:"Ho wlong did it take you?",
    isNew:true,
  },
  {
    id: 231,
    category: 5,
    name: "Size it Up",
    url: "https://magnitudle.com/size-it-up",
    image: "magnitudle.png",
    caption: "Guess the relative size of two things",
    scoreType: "int[3]",
    scorePrompt:"Total score",
    isNew:true,
  },
  {
    id: 232,
    category: 9,
    name: "Magnitudle Daily",
    url: "https://magnitudle.com/daily",
    image: "magnitudle.png",
    caption: "Guess a numeric answer within an order of magnitude",
    scoreType: "int[3]",
    scorePrompt:"What was your score?",
    isNew:true,
  },
  {
    id: 233,
    category: 4,
    name: "Mathdle",
    url: "https://mathdle.app",
    image: "mathdle.png",
    caption: "Create an arithmetic expression that equals the target",
    scoreType: "time",
    scorePrompt:"How long did it take you?",
    isNew:true,
  },
  {
    id: 234,
    category: 4,
    name: "mystery-o-matic",
    url: "https://mystery-o-matic.com/",
    image: "mysteryomatic.png",
    caption: "Solve a murder using clues and deduction",
    isNew:true,
  },
  {
    id: 235,
    category: 5,
    name: "Nodes",
    url: "https://www.nodes-game.com",
    image: "nodes.png",
    caption: "Connect the dots to paint a mosaic image",
    scoreType: "int[3]",
    scorePrompt:"What was your accuracy score?",
    isNew:true,
  },
  {
    id: 236,
    category: 4,
    name: "Number Waffle",
    url: "https://wafflegame.net/numberwaffle",
    image: "numberwaffle.png",
    caption: "Swap numbers around to solve a Sudoku-like grid",
    scoreType: "int[1]",
    scorePrompt: "How many stars did you earn?",
    isNew:true,
  },
  {
    id: 237,
    category: 6,
    name: "OpenGuessr",
    url: "https://openguessr.com/",
    image: "openguessr.png",
    caption: "Geoguess a location using Google Maps street view",
    isNew:true,
  },
  {
    id: 238,
    category: 1,
    name: "Outlier",
    url: "https://playoutlier.com",
    image: "outlier.png",
    caption: "Make rare words using the given letters.",
    scoreType: "int[3]",
    scorePrompt:"What was your final score?",
    isNew:true,
  },
  {
    id: 239,
    category: 1,
    name: "Parseword",
    url: "https://www.parseword.com/",
    image: "parseword.png",
    caption: "Solve a daily cryptic crossword clue by the creator of Wordle.",
    scoreType: "time",
    scorePrompt:"What was your time (with no assists)?",
    isNew:true,
  },
  {
    id: 240,
    category: 5,
    name: "Picsey",
    url: "https://picsey.io",
    image: "picsey.png",
    caption: "Reveal tiles then guess what the picture shows",
    scoreType: "int[3]",
    scorePrompt:"How many points did you get?",
    isNew:true,
  },
  {
    id: 241,
    category: 4,
    name: "Pile-Up Poker",
    url: "https://www.puzzmo.com/play/pile-up-poker",
    image: "pileuppoker.png",
    caption: "Play cards into a grid to form poker hands in rows and columns",
    scoreType: "int[4]",
    scorePrompt:"How many points did you earn?",
    isNew:true,
  },
  {
    id: 242,
    category: 4,
    name: "Pivots",
    url: "https://playpivots.com",
    image: "pivots.png",
    caption: "Sort the row of numbers, like solving a Rubik's Cube",
    isNew:true,
  },
  {
    id: 243,
    category: 7,
    name: "PokeCryptic",
    url: "https://pokecryptic.com/",
    image: "pokecryptic.png",
    caption: "Solve a cryptic puzzle... about Pokemon",
    scoreType: "int[2]",
    scorePrompt:"How many hints did you use?",
    isNew:true,
  },
  {
    id: 244,
    category: 7,
    name: "Pokennection",
    url: "https://www.pokennection.com/",
    image: "pokennection.png",
    caption: "Sort 16 Pokemon into 4 groups",
    scoreType: "int[1]",
    scorePrompt:"How many pokeballs remaining?",
    isNew:true,
  },
  {
    id: 245,
    category: 7,
    name: "PunFiction",
    url: "https://iwandres.github.io/PunFiction/boxofficeblunders/",
    image: "punfiction.png",
    caption: "Guess a corny parody movie title",
    scoreType: "int[1]",
    scorePrompt:"Number of hints used",
    isNew:true,
  },
  {
    id: 246,
    category: 5,
    name: "Bloxist",
    url: "https://www.puzzleship.com/logic/bloxist",
    image: "bloxist.png",
    caption: "Maneuver a block through an isometric level",
    scoreType: "int[1]",
    scorePrompt:"How many of today's levels did you complete?",
    isNew:true,
  },
  {
    id: 247,
    category: 1,
    name: "Rabbit Hole",
    url: "https://rabbit-hole-game.com/",
    image: "rabbithole.png",
    caption: "Connect two words using synonyms, antonyms and rhymes",
    scoreType: "int[1]",
    scorePrompt:"How many hops did you make?",
    isNew:true,
  },
  {
    id: 248,
    category: 8,
    name: "References",
    url: "https://referencesgame.com/",
    image: "references.png",
    caption: "Guess a word using as few of the clues as possible",
    scoreType: "int[2]",
    scorePrompt:"How many stars did you end with?",
    isNew:true,
  },
  {
    id: 249,
    category: 2,
    name: "Reunion",
    url: "https://www.merriam-webster.com/games/reunion",
    image: "reunion.png",
    caption: "Swap letters (and woodland creatures) to form words.",
    isNew:true,
  },
  {
    id: 250,
    category: 2,
    name: "Ribbit",
    url: "https://www.puzzmo.com/play/ribbit",
    image: "ribbit.png",
    caption: "Form words to clear letters and uncover frogs beneath.",
    scoreType: "int[4]",
    scorePrompt:"How many points did you get?",
    isNew:true,
  },
  {
    id: 251,
    category: 9,
    name: "Runes",
    url: "https://dailyrunes.com/",
    image: "runes.png",
    caption: "Form words on spinning letter rings.",
    scoreType: "int[2]",
    scorePrompt:"How many guesses did you use?",
    isNew:true,
  },
  {
    id: 252,
    category: 9,
    name: "Scooch",
    url: "https://playscooch.com",
    image: "scooch.png",
    caption: "Scooch jumbled letters into the correct positions.",
    scoreType: "int[2]",
    scorePrompt:"How many scooches (on Chill mode)?",
    isNew:true,
  },
  {
    id: 253,
    category: 9,
    name: "Scrandle",
    url: "https://scrandle.com/",
    image: "scrandle.png",
    caption: "Guess which of two dishes is more popular",
    scoreType: "int[2]",
    scorePrompt:"How many did you guess out of 10?",
    isNew:true,
  },
  {
    id: 254,
    category: 8,
    name: "Seldom",
    url: "https://www.playseldom.com",
    image: "seldom.png",
    caption: "Think of rare responses to the prompt",
    scoreType: "int[3]",
    scorePrompt:"Score",
    isNew:true,
  },
  {
    id: 255,
    category: 3,
    name: "Sexaginta-quattuordle",
    url: "https://64ordle.au/?mode=daily",
    image: "sexaginta.png",
    caption: "Solve 64 Wordles at once. Sure.",
    scoreType: "int[3]",
    scorePrompt:"How many guesses did you make?",
    isNew:true,
  },
  {
    id: 256,
    category: 3,
    name: "Shuntle",
    url: "https://shuntle.com/",
    image: "shuntle.png",
    caption: "Wordle with different word lengths",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did you use?",
    isNew:true,
  },
  {
    id: 257,
    category: 7,
    name: "Songless",
    url: "https://lessgames.com/songless",
    image: "songless.png",
    caption: "Name that tune with short intro clips",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did you use?",
    isNew:true,
  },
  {
    id: 258,
    category: 1,
    name: "Acrostic",
    url: "https://www.sporcle.com/acrostic/play",
    image: "acrostic.png",
    caption: "Solve the phrase with letters shuffled in from clues",
    scoreType: "time",
    scorePrompt:"How long did you take?",
    isNew:true,
  },
  {
    id: 259,
    category: 3,
    name: "Jourdle",
    url: "https://jourdle.com/",
    image: "jourdle.png",
    caption: "Play a 3-Word Wordle puzzle, collaborating with a buddy",
    isNew:true,
  },
  {
    id: 260,
    category: 1,
    name: "The Loop",
    url: "https://www.britannica.com/games/loop",
    image: "loop2.png",
    caption: "Connect the pictures in a ring by their similarities",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did you have left?",
    isNew:true,
  },
  {
    id: 261,
    category: 5,
    name: "Thruline",
    url: "https://cyllibi.com/thruline/",
    image: "thruline.png",
    caption: "Guess a word related to four images, one image at a time.",
    scoreType: "int[1]",
    scorePrompt:"How many images did you reveal?",
    isNew:true,
  },
  {
    id: 262,
    category: 2,
    name: "Tiled Words",
    url: "https://tiledwords.com/",
    image: "tiledwords.png",
    caption: "Move and spin the letter tiles to solve a crossword puzzle.",
    scoreType: "time",
    scorePrompt:"How long did you take?",
    isNew:true,
  },
  {
    id: 263,
    category: 1,
    name: "TillyFlip",
    url: "https://www.tillyflip.com/",
    image: "tillyflip.png",
    caption: "Flip letters to guess five words before your 15 lives run out.",
    scoreType: "int[2]",
    scorePrompt:"How many lives were remaining?",
    isNew:true,
  },
  {
    id: 264,
    category: 1,
    name: "Traversle",
    url: "https://traversle.io/",
    image: "traversle.png",
    caption: "Connect two words by selecting a path of related words",
    scoreType: "int[2]",
    scorePrompt:"How many steps did you use?",
    isNew:true,
  },
  {
    id: 265,
    category: 2,
    name: "Tungle",
    url: "https://www.tungle.app/",
    image: "tungle.png",
    caption: "Drag and connect letters to find words in a grid.",
    scoreType: "int[4]",
    scorePrompt:"How many points did you earn?",
    isNew:true,
  },
  {
    id: 266,
    category: 6,
    name: "Vexle",
    url: "https://vexle.org",
    image: "vexle.png",
    caption: "Sketch a country's flag from memory.",
    scoreType: "int[3]",
    scorePrompt:"What was your percentage score?",
    isNew:true,
  },
  {
    id: 267,
    category: 9,
    name: "Patentle",
    url: "https://patentle.vexle.org/#/",
    image: "patentle.png",
    caption: "Reinvent something by combining items together",
    scoreType: "int[3]",
    scorePrompt:"What was your efficiency score?",
    isNew:true,
  },
  {
    id: 268,
    category: 2,
    name: "Weaver X",
    url: "https://wordwormdormdork.com/weaver-x/",
    image: "weaverx.png",
    caption: "Change or resize a word one letter at a time to match the target.",
    scoreType: "int[2]",
    scorePrompt:"How many steps did you use?",
    isNew:true,
  },
  {
    id: 269,
    category: 2,
    name: "Wend",
    url: "https://www.linkedin.com/games/wend/",
    image: "wend.png",
    caption: "Weave through a letter grid to uncover daily words.",
    scoreType: "time",
    scorePrompt:"How long did it take you?",
    isNew:true,
  },
  {
    id: 270,
    category: 5,
    name: "Wirespan",
    url: "https://wirespan.app",
    image: "wirespan.png",
    caption: "Place power lines to efficiently power the grid",
    scoreType: "int[3]",
    scorePrompt:"What was your efficiency score?",
    isNew:true,
  },
  {
    id: 271,
    category: 9,
    name: "WordBridge",
    url: "https://wordbridge.danielgallab.com",
    image: "wordbridge.png",
    caption: "Connect two words with a path of related words",
    scoreType: "int[2]",
    scorePrompt:"How many words did you use?",
    isNew:true,
  },
  {
    id: 272,
    category: 2,
    name: "Word Weld",
    url: "https://wordweld.redividers.app/",
    image: "wordweld.png",
    caption: "Reorder words so they merge and split into new valid words.",
    scoreType: "time",
    scorePrompt:"How long did it take (with no hints)?",
    isNew:true,
  },
  {
    id: 273,
    category: 2,
    name: "Wordfive",
    url: "https://playwordfive.com/",
    image: "wordfive.png",
    caption: "Fill the grid in with the provided letters",
    scoreType: "time",
    scorePrompt:"How long did it take?",
    isNew:true,
  },
  {
    id: 274,
    category: 2,
    name: "Wordspine Sprint",
    url: "https://wordspine.com/sprint",
    image: "wordspinesprint.png",
    caption: "Build words by filling in extra letters",
    scoreType: "time",
    scorePrompt:"How much time did it take?",
    isNew:true,
  },
  {
    id: 280,
    category: 2,
    name: "Wordspine Pro",
    url: "https://wordspine.com/pro",
    image: "wordspinepro.png",
    caption: "Build words by filling in extra letters",
    scoreType: "time",
    scorePrompt:"What was your total score?",
    isNew:true,
  },
  {
    id: 275,
    category: 2,
    name: "WRD LINK",
    url: "https://www.wrdlink.io/",
    image: "wrdlink.png",
    caption: "Change one letter at a time to reach the target word.",
    scoreType: "int[2]",
    scorePrompt:"How many words used over 3 levels?",
    isNew:true,
  },
  {
    id: 276,
    category: 7,
    name: "WrestlePlay",
    url: "https://wrestleplay.com/wrestling-grid",
    image: "wrestleplay.png",
    caption: "Select wrestlers based on the row and column prompts",
    isNew:true,
  },
  {
    id: 277,
    category: 8,
    name: "Yearbook",
    url: "https://yearbook.hindsightgames.com/",
    image: "yearbook.png",
    caption: "Guess the year based on pop culture clues",
    scoreType: "int[1]",
    scorePrompt:"How many guesses did you use?",
    isNew:true,
  },
  {
    id: 278,
    category: 5,
    name: "Zip",
    url: "https://www.linkedin.com/games/zip",
    image: "zip.png",
    caption: "Draw one line through all the numbers in order",
    scoreType: "time",
    scorePrompt:"How long did it take?",
    isNew:true,
  },
  {
    id: 279,
    category: 5,
    name: "Queens",
    url: "https://www.linkedin.com/games/queens/?skipRedirect=true",
    image: "queens.png",
    caption: "Find the queens in the grid",
    scoreType: "time",
    scorePrompt:"How long did you take?",
    isNew:true,
  },
];

export const davesPicksGameIds = [
  196, // Boston mini
  232, // Magnitudle
  80,  // Hocus Focus
  41,  // One Word Search
  262, // Tiled words
  99,  // TimeGuessr
  11,  // Raddle
  59,  // Waffle
  274, // Wordspine sprint
  13,  // Hang five
	169, // Graphs
  6,   // Connections
  130, // Real Bird Fake Bird
  47,  // Wordle
  254, // Seldom
  22,  // Crosswordle
  145, // Stars
  237, // OpenGuessr
  60,  // Word Peaks
  42,  // Stack Down
  12,  // Bracket City
  9,   // Strands
  36,  // Squeezy 
  194, // Blinkle
  200, // Cascadle
  106, // FoodGuessr
  231, // Size it up
  198, // Cadgy
  279, // Queens
  263, // Tilly flip
  230, // Loopy river
  280, // Wordspine pro
  253, // Scrandle
  227, // LA mini
  270, // Wirespan
  260, // The Loop
  241, // Pile up poker
  76,  // Minute cryptic
  66,  // Cubisum
  174, // I'm not a robot
  171, // Colorguessr
  132, // Catfishing
  44,  // wridges
  142, // Forgeous
  69,  // Sudoku: easy
  236, // Number waffle
  192, // AITA guesser
  214, // Eightile
  167, // WhichWay
  258, // Acrostic
  269, // Wend
  242, // Pivots
  248, // References
  268, // Weaver X
  191, // 4x3
  203, // Circuits
  74,  // Pips - Medium
  99,  // TimeGuessr
  166, // Wordsmyth
  259, // Jourdle
  238, // Outlier
  239, // Password
  225, // Impress
  251, // Runes
  265, // Tungle
  264, // Traversle
];

export const categories = [
  {id:2, label:"Word Puzzles", shortLabel:"Word", description:"Games about vocabulary and word recognition", color:"#8cb6b3"},
  {id:1, label:"Language Games", shortLabel:"Language", description:"Puzzles that involve meaning and context", color:"#9ac593"},
  {id:3, label:"Wordle Variants", shortLabel:"Wordle-likes", description:"Spin-offs of the popular word guessing game", color:"#7fa0c5"},
  {id:4, label:"Math & Logic", shortLabel:"Logic", description:"Puzzles involving numbers and logical deduction", color:"#a993c5"},
  {id:5, label:"Visual/Spatial", shortLabel:"Visual", description:"Games based on graphical or spatial components", color:"#c59696"},
  {id:6, label:"Geography", shortLabel:"Geography", description:"Challenges involving places around the world", color:"#b6a993"},
  {id:7, label:"Pop Culture", shortLabel:"Pop Culture", description:"Puzzles about movies, music, sports, games, etc.", color:"#bdc586"},
  {id:8, label:"General Trivia", shortLabel:"Trivia", description:"Trivia challenges about various subjects", color:"#7ba285"},
  {id:9, label:"Miscellaneous", shortLabel:"Misc", description:"Various games that don't fit the usual categories", color:"#999999"}
]

// Default accent color for a game, based on its category. Games don't carry
// their own color (200+ of them) — this keeps the palette manageable.
export const DEFAULT_GAME_COLOR = "#8892b0";
export const getGameColor = (game) => {
  const category = categories.find(c => c.id === game?.category);
  return category?.color || DEFAULT_GAME_COLOR;
};